import React, { createContext } from "react";

export const WidgetContext = createContext(null);
